import axios from 'axios';
import { KjedeNedleggelseKandidatDto, KjedeNedleggelseResultat } from './types';
import { getKjederegAdminApiUrl } from '../../';

const baseUrl = getKjederegAdminApiUrl() + '/kjeder';

async function getKandidater(): Promise<KjedeNedleggelseKandidatDto[]> {
  const response = await axios.get(`${baseUrl}/nedleggelseskandidater`);
  return response.data;
}

async function leggNed(kjedeIds: number[], dato?: string): Promise<KjedeNedleggelseResultat[]> {
  const response = await axios.post(`${baseUrl}/legg-ned`, { kjedeIds, dato });
  return response.data;
}

export default { getKandidater, leggNed };
